import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core'
import { PreviewButton } from './PreviewButton'
import moment from 'moment'
import React, { useState } from 'react'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import ReactQuill from 'react-quill'
import './EmailsHistory.css'
import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { EMAIL_RECIPIENTS_TYPES } from '..'

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 600,
  },
})

const EmailRow = (props) => {
  const { email } = props
  const [open, setOpen] = useState(false)

  const recipients = email.recipients.join(', ')

  return (
    <React.Fragment>
      <TableRow
        sx={{
          '&:last-child td, &:last-child th': {
            border: 0,
          },
        }}
        style={{ backgroundColor: email.sentAt ? 'white' : '#ffcccc' }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          {email.sentAt ? (
            moment(email.sentAt).format('DD/MM/YYYY HH:mm')
          ) : email.errorDescription ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <p>Non envoyé</p>
              <Tooltip title={email.errorDescription} placement="right">
                <ErrorOutlineIcon sx={{ marginLeft: '10px' }} />
              </Tooltip>
            </div>
          ) : (
            <p>Non envoyé</p>
          )}
        </TableCell>
        <TableCell>{email.subject}</TableCell>
        <TableCell>
          {email.mondayCoproCode ? email.mondayCoproCode : 'Non renseignée'}
        </TableCell>
        <TableCell>
          {email.sendingMode === EMAIL_RECIPIENTS_TYPES.BCC ? 'Oui' : 'Non'}
        </TableCell>
        <TableCell>{email.isSentToCSMember ? 'Oui' : 'Non'}</TableCell>
        <TableCell>
          {recipients.length > 150 ? (
            <CustomWidthTooltip title={recipients} placement="left">
              <p>{recipients.substring(0, 150) + '...'}</p>
            </CustomWidthTooltip>
          ) : (
            recipients
          )}
        </TableCell>
        <TableCell align="center">
          {email.attachments?.length > 0 &&
            email.attachments.map((attachment, index) => (
              <PreviewButton url={attachment} key={index} />
            ))}
        </TableCell>
        <TableCell>{email.senderEmail}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{
            paddingBottom: 0,
            paddingTop: 0,
          }}
          colSpan={8}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <ReactQuill
                value={email.body}
                readOnly={true}
                modules={{ toolbar: false }}
                className="no-border-quill"
              />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

export const EmailsHistory = ({
  emails,
  classes,
  handleChangePage,
  handleChangeRowsPerPage,
}) => (
  <div className={classes.sendingForm}>
    <TableContainer
      style={{
        marginTop: '2em',
      }}
    >
      <Table sx={{ minWidth: 650 }} size="small">
        <TableHead>
          <TableRow
            sx={{
              fontSize: '0.875em',
              '& th': {
                fontSize: '0.875em',
              },
            }}
          >
            <TableCell className={classes.tableHeader} />
            <TableCell className={classes.tableHeader}>Date d'envoi</TableCell>
            <TableCell className={classes.tableHeader}>Objet</TableCell>
            <TableCell className={classes.tableHeader}>Copro</TableCell>
            <TableCell className={classes.tableHeader}>Envoyé en CCI</TableCell>
            <TableCell width="10%" className={classes.tableHeader}>
              Envoyé à un membre du CS
            </TableCell>
            <TableCell className={classes.tableHeader}>Destinataires</TableCell>
            <TableCell className={classes.tableHeader} align="center">
              PJ
            </TableCell>
            <TableCell className={classes.tableHeader}>
              Opérateur qui a envoyé l'email
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {emails.rows.map((email) => (
            <EmailRow key={email.id} email={email} />
          ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={emails.count}
        rowsPerPage={emails.rowsPerPage}
        page={emails.page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Nombre par page"
      />
    </TableContainer>
  </div>
)
